const searchParams = (url = window.location.href) => {
  const defaultUrl = url instanceof URL ? url : new URL(url);
  return new window.URLSearchParams(defaultUrl.search);
};

export default searchParams;
